import type { TTournamentBadge } from '@/api/cms';

export const badgeGradientMap: Record<TTournamentBadge, string> = {
  low_competition: 'green-gradient',
  more_chances: 'green-gradient',
  de_only: 'purple-gradient',
  ca_only: 'purple-gradient',
  au_only: 'purple-gradient',
  nz_only: 'purple-gradient',
  ch_only: 'purple-gradient',
  ie_only: 'purple-gradient',
  no_only: 'purple-gradient',
  vip_only: 'gold-gradient',
  rush_24h: 'red-gradient',
  rush_12h: 'red-gradient',
  telegram: 'blue-gradient',
  branded_game: 'orange-gradient',
  new_mechanics: 'pink-gradient',
};
